var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19526 4.86193C4.43558 4.62161 4.81374 4.60312 5.07527 4.80647L5.13807 4.86193L11.7377 11.4616C11.9981 11.7219 11.9981 12.1441 11.7377 12.4044C11.4974 12.6447 11.1193 12.6632 10.8577 12.4599L10.7949 12.4044L4.19526 5.80474C3.93491 5.54439 3.93491 5.12228 4.19526 4.86193Z",
    fill: "#DA4B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19526 12.4044C4.43558 12.6447 4.81374 12.6632 5.07527 12.4599L5.13807 12.4044L11.7377 5.80474C11.9981 5.54439 11.9981 5.12229 11.7377 4.86194C11.4974 4.62161 11.1193 4.60313 10.8577 4.80648L10.7949 4.86194L4.19526 11.4616C3.93491 11.7219 3.93491 12.1441 4.19526 12.4044Z",
    fill: "#DA4B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.efdfc4ea34ce08f2f834a9c038b09721.svg";
export { ForwardRef as ReactComponent };